// This function strips out the lot extension from the headline
// There is some nuance to this because not all records follow the same
// format, but we're essentially looking for some form of "-A)" with variations
// of white space and the ommission of '-'

/*export const parseLotHeadlineMess = (headlineMess: string): Record<string, string> => {
  const r = /(.*)[^A-Za-z]?\s*([A-Za-z])\s*\)(.*)/;
  const matches = headlineMess?.match(r);

  return matches ? {
    // This replace is because I fought regex for hours trying to get one that could handle
    // a - before the lot extension as well as the format of extension items without it and
    // I'm tired of fighting it
    lotHeadline: matches[1].trim().replace(/\s*-$/, ''),
    extension: matches[2],
    extensionHeadline: matches[3].trim(),
  } : {
    lotHeadline: headlineMess,
  };
};
*/

export type ParsedHeadlineMess = {
  lotHeadline: string,
  extensionHeadline?: string,
  extension?: string,
};

export const parseLotHeadlineMess = (headlineMess: string, lotExt?: string): ParsedHeadlineMess => {
  // default return is just the whole thing as the main headline
  let ret = {
    lotHeadline: headlineMess,
  };

  // We are going to walk char by char looking for capital letters
  // which are bounded by nothing other than space, '-' on the left,
  // or ')' on the right
  for(let i = 0; i < headlineMess.length; i++) {
    const c = headlineMess[i];

    // We were just looking for capital letters, but reducing the needle to be
    // just the expected lot extension letter reduces many false positives
    if(c == (lotExt || 'A').toUpperCase()) {
      let beforeValid = false;
      // don't go before index 0
      let beforeIndex = i - 1 >= 0 ? i - 1 : 0;

      // walk backwards.  If we hit '-' this is a valid candidate
      // if it's a space we're not sure, keep going
      // if it's anything else we're not valid here
      for(let j = i - 1; j > 0; j--) {
        const bc = headlineMess[j];

        if(bc == '-') {
          beforeValid = true;
          beforeIndex = j;
          break;
        } else if( !(bc == ' ') ) {
          break;
        } else {
          beforeIndex = j;
        }
      }

      let afterValid = false;
      // don't go passed last char index
      let afterIndex = i + i < (headlineMess.length - 1) ? i + i : headlineMess.length -1;


      // walk forwards.  If we hit ')' this is a valid candidate
      // if it's a space we're not sure, keep going
      // if it's anything else we're not valid here
      for(let k = i + 1; k < headlineMess.length; k++) {
        const ac = headlineMess[k];
        afterIndex = k;
        if(ac == ')') {
          afterValid = true;
          // no break here, we want to run 1 char forward for sending to String.prototype.slice
        } else if( !(' -'.includes(ac)) ) {
          break;
        }
      }

      // If we are valid in either direction test further, if not we
      // continue the main loop
      if((beforeValid || afterValid)) {
        const slice = headlineMess.slice(beforeIndex, afterIndex);
        const allowed = `-${c}) `;

        // Test the substring enclosed by the char indexes we walked to.
        // the allowed character set is defined above, but is basically
        // the capital letter we've match as well as '-', ')', and space
        // If there is anything else in there it's not a valid match
        let pass = true;
        for(let l = 0; l < slice.length; l++) {
          if( !allowed.includes(slice[l]) ) {
            pass = false;
            break;
          }
        }

        if(afterValid == false) {
          if(i + 1 < headlineMess.length) {
            if(headlineMess[i + 1] != ' ') {
              pass = false;
            }
          }
        }

        // If we've made it this far we have a match
        if(pass) {
          ret = {
            lotHeadline: headlineMess.slice(0, beforeIndex).trim(),
            extensionHeadline: headlineMess.slice(afterIndex).trim(),
            extension: c,
          };

          break;
        }
      }
    }
  }

  return ret;
};